import PropTypes from 'prop-types'
import { useState } from 'react'
import classNames from 'classnames'
import AssetAddModal from 'features/creative/add/build/AssetAddModal'
import NoneAnchor from 'components/NoneAnchor'

const CreativeAssets = ({
  onConfirmAssetAdd,
  assetNums,
  disabled,
  children,
}) => {
  const [showAssetAddModal, setShowAssetAddModal] = useState(false)
  const [showAssets, setShowAssets] = useState(true)
  return (
    <>
      <div className="add_material">
        <div className="material_item">
          <div className="tit_itemwrap">
            <strong
              onClick={() => setShowAssets(!showAssets)}
              className={classNames('tit_item', {
                off: !showAssets,
                in_active: disabled,
              })}>
              확장소재 <span className="fc_emph">{assetNums} </span>
              <span
                className={classNames('ico_comm', { ico_arr: assetNums > 0 })}>
                내용 더보기
              </span>
            </strong>
          </div>
          <div className="desc_item">
            <NoneAnchor
              className={classNames('btn_gm gm_bl', { in_active: disabled })}
              onClick={() => setShowAssetAddModal(true)}>
              <span className="inner_g">
                <span className="img_comm ico_add" />
                확장소재 추가하기
              </span>
            </NoneAnchor>
            <span className="txt_item">
              확장소재를 등록하면 더 많은 지면에 광고노출 기회를 얻을 수 있으며,
              광고 클릭률이 증가합니다.
            </span>
            <AssetAddModal
              on={showAssetAddModal}
              handleClose={() => setShowAssetAddModal(false)}
              onClickConfirm={onConfirmAssetAdd}
            />
          </div>
        </div>
      </div>
      <div style={{ display: showAssets ? null : 'none' }}>{children}</div>
    </>
  )
}

export default CreativeAssets

CreativeAssets.propTypes = {
  children: PropTypes.node.isRequired,
  assetNums: PropTypes.number.isRequired,
  onConfirmAssetAdd: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
}
